import { Map, OrderedMap } from 'immutable'
import fetchJSON from 'lib/fetchJSON'
import { fulfilled, pending } from 'lib/promiseMiddlewareHelpers'

export const ADD = 'comments/ADD'
export const DELETE = 'comments/DELETE'
export const LOAD = 'comments/LOAD'

// TODO: This map is duplicated in ridewithgps/lib/extensions/comment_parent_type.rb and needs to be kept in sync.
// If a parent type is added in one place, it needs to be added in the other for comments to work.
// https://github.com/ridewithgps/ridewithgps/blob/beta/lib/extensions/comment_parent_type.rb
const PARENT_TYPE_MAP = {
  1: 'gear',
  3: 'trip',
  4: 'photo',
  6: 'route',
  11: 'club_message',
  12: 'ride_report',
  13: 'segment',
  14: 'comment'
}

// The main data structure in the state is a multi-level map 'parent_type' -> 'parent_id' -> OrderedMap(id -> comment)

export const reducer = (state = Map(), action = {}) => {
  switch (action.type) {
    case fulfilled(ADD): {
      const { parentType, parentId } = action.meta
      return state.setIn([parentType, parentId, 'comments', action.payload.id], action.payload)
    }
    case fulfilled(LOAD): {
      return state.withMutations(s => {
        action.payload.comments.map(comment => {
          let nextState = s.getIn([PARENT_TYPE_MAP[comment.parent_type_id], comment.parent_id, 'comments'], OrderedMap())
          nextState = nextState.set(comment.id, comment)
          s.setIn([PARENT_TYPE_MAP[comment.parent_type_id], comment.parent_id, 'comments'], nextState)
        })
        return s
      })
    }
    case pending(DELETE): {
      const { parentType, parentId, commentId } = action.meta
      return state.deleteIn([PARENT_TYPE_MAP[parentType], parentId, 'comments', commentId])
    }
    default:
      return state
  }
}

export const submitComment = (parentType, parentId, privacyCode, comment) => ({
  type: ADD,
  payload: fetchJSON(`/comments.json`, {
    parent_type: parentType,
    parent_id: parentId,
    response_as_data: true,
    comment,
    privacy_code: privacyCode
  },
  { method: 'POST' }),
  meta: { parentId, parentType }
})

export const deleteComment = (parentType, parentId, commentId) => ({
  type: DELETE,
  payload: fetchJSON(`/comments/${commentId}.json`, {}, { method: 'DELETE' }),
  meta: { parentType, parentId, commentId }
})

export const loadComments = (parentType, parentId, privacyCode) => ({
  type: LOAD,
  payload: fetchJSON(`/comments.json?parent_type=${parentType}&parent_id=${parentId}${privacyCode ? `&privacy_code=${privacyCode}` : ''}`),
  meta: { parentId, parentType }
})
